import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import IdentityProviderPage from '~components/identity-providers/identity-provider-page';
import IdentityProviderSearch from '~components/identity-providers/identity-provider-search';
import StandardPage from '~components/pages/standard-page';

function IdentityProvidersPage() {

  const { path } = useRouteMatch();

  return (
    <StandardPage>
      <Switch>
        <Route path={`${path}/:identityProviderId`} render={(props) => <IdentityProviderPage {...props} />} />
        <Route path={`${path}`} component={IdentityProviderSearch} />
      </Switch>
    </StandardPage>
  );
}

export default IdentityProvidersPage;
